import React, { useMemo } from "react";
// stylesheet
import "@frameworks/shared-library/stylesheets/components/TransactionJourney/MandateType/MandateType.scss";
// components
import RadioButton from "@frameworks/web/components/generic/radioButton";
// types
import { EHoldingType } from "@domains/features/Markets/AIF-PMS/entities/PurchaseEntity";
export var RadioTypes = [
    { value: "RTGS", display: "RTGS" },
    { value: "Cheque", display: "Cheque" },
];
export var createPhysicalList = function (type) {
    switch (type) {
        case EHoldingType.RTGS:
            return { value: EHoldingType.RTGS, display: "RTGS" };
        case EHoldingType.Cheque:
            return { value: EHoldingType.Cheque, display: "Cheque" };
        default:
    }
};
var RadioType = function (_a) {
    //
    var recommendedType = _a.recommendedType, availableList = _a.availableList, selected = _a.selected, setPhysicalFlg = _a.setPhysicalFlg, disable = _a.disable;
    var physicalList = useMemo(function () {
        return ((availableList === null || availableList === void 0 ? void 0 : availableList.length) > 0 &&
            availableList.map(function (x) { return createPhysicalList(x); }));
    }, [availableList]);
    return (React.createElement("div", { className: "primary-mandate-radio-btns-container d-flex" }, (physicalList === null || physicalList === void 0 ? void 0 : physicalList.length) > 0 &&
        physicalList.map(function (item, count) {
            return (React.createElement(RadioButton, { name: "RadioTypes", list: item, onChange: function (e) {
                    setPhysicalFlg(e.target.value);
                }, selected: selected, key: count, disabled: disable, className: "common-radio-button  selected-desk-tab", bottomChildComp: item.value === recommendedType ? (React.createElement("div", { className: "recommendedContainer d-flex flex-column justify-content-center" },
                    React.createElement("span", { className: "DMSanN_8_400 recommentdedText" }, "Recommended"))) : (React.createElement(React.Fragment, null)) }));
        })));
};
export default RadioType;
